export default "__VITE_ASSET__c3477605__"